import { Model } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import { Hand, ISolution } from 'pokersolver'

export const getUserHandSolution = ({
  cards,
  gameHand,
}: {
  cards: Model.UserHand['cards']
  gameHand: Model.GameHand
}) => {
  return Hand.solve([...cards, ...gameHand.visibleCards])
}
